import React, { useCallback, useEffect, useState } from "react";
import MyEarning from "../../../Components/Earning/MyEarning";
import Layout from "../../../Components/Layout";
import useHttpHook from "../../../Hooks/HttpHook";
import { GetOrganizerEarningDetails } from "../../../utils/ApiConstant";
import { createObjectForPaginatedResult } from "../../../utils/Helper";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../utils/notify";

const initialDateRange = { startDate: "", endDate: "" };
const initialAppliedFilter = {
  mode: "span",
  timeSpan: "",
  startDate: "",
  endDate: "",
};
const MyEarningPage = () => {
  const [details, setDetails] = useState({});
  const [loading, sendRequest, error] = useHttpHook();
  const [searchInput, setSearchInput] = useState("");
  const [timeSpanInput, setTimeSpanInput] = useState("");
  const [dateRange, setDateRange] = useState(initialDateRange);
  const [appliedFilter, setAppliedFilter] = useState(initialAppliedFilter);
  const [isShowDateFilter, setIsShowDateFilter] = useState(true);

  useEffect(() => {
    if (searchInput.length >= 3) {
      getDetails();
    }

    if (searchInput === "") {
      getDetails();
    }
  }, [searchInput]);
  useEffect(() => {
    getDetails();
  }, [appliedFilter]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);
  const getDetails = async (page = 1) => {
    const query =
      appliedFilter.mode === "range"
        ? `&startDate=${encodeURIComponent(appliedFilter.startDate)}&endDate=${encodeURIComponent(appliedFilter.endDate)}`
        : `&timeSpan=${encodeURIComponent(appliedFilter.timeSpan || "")}`;
    try {
      let response = await sendRequest(
        `${GetOrganizerEarningDetails}?page=${page}&search=${encodeURIComponent(searchInput)}${query}`,
        {
          method: "get",
        }
      );
      if (response.status === 1)
        if (page === 1) {
          setDetails(response.data);
        } else {
          setDetails((prevState) => {
            const data = createObjectForPaginatedResult(
              response.data.topSalingEvents,
              prevState.topSalingEvents,
              "paginate"
            );
            return {
              ...prevState,
              topSalingEvents: data,
            };
          });
        }
    } catch (error) {
      console.log(error);
    }
  };
  // console.log(details, "--------------pragya--------");
  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  const handleTimeSpan = (timeSpan) => {
    setDateRange(initialDateRange);
    setTimeSpanInput(timeSpan);
    setAppliedFilter({
      mode: "span",
      timeSpan,
      startDate: "",
      endDate: "",
    });
  };

  const handleDateRange = (e) => {
    let temp = { ...dateRange };
    temp[e.target.name] = e.target.value;
    setDateRange(temp);
  };

  const handleDateRangeSubmit = (e) => {
    e.preventDefault();
    if (!dateRange.startDate || !dateRange.endDate) {
      toast.error("Please select a start and end date.");
      return;
    }
    if (dateRange.startDate > dateRange.endDate) {
      toast.error("Start date should be less than end date.");
      return;
    }
    setTimeSpanInput("");
    setAppliedFilter({
      mode: "range",
      timeSpan: "",
      startDate: dateRange.startDate,
      endDate: dateRange.endDate,
    });
  };
  return (
    <Layout
      Heading="My Earning"
      TitleMark={true}
      TitleMarkClassName="event-my-earnings-title-mark"
      TitleClassName="event-my-earnings-title"
      HeadClassName="event-my-earnings-head"
      ExtraclassName="event-my-earnings-panel"
      activeMenuId="my-earnings"
    >
      <MyEarning
        isError={error}
        isLoading={loading}
        details={details}
        setDetails={setDetails}
        getDetails={getDetails}
        handleSearchChange={handleSearchChange}
        searchInput={searchInput}
        dateRange={dateRange}
        handleTimeSpan={handleTimeSpan}
        handleDateRange={handleDateRange}
        timeSpanInput={timeSpanInput}
        handleDateRangeSubmit={handleDateRangeSubmit}
        isShowDateFilter={isShowDateFilter}
      />
    </Layout>
  );
};

export default MyEarningPage;
